<template>
    <div>
        <a
            v-if="type !== 'router'"
            :href="href"
            :target="target"
            class="ml-3 p-2 font-semibold text-gray-200 hover:text-white max-w-xs flex items-center text-sm cursor-pointer"
            @click="$emit('click')"
        >
            <slot></slot>
        </a>
        <router-link
            v-if="type === 'router'"
            :to="href"
            class="ml-3 p-2 font-semibold text-gray-200 hover:text-white max-w-xs flex items-center text-sm focus:outline-none cursor-pointer"
            @click.native="$emit('click')"
        >
            <slot></slot>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'header-link',
        props: {
            href: String,
            title: String,
            target: String,
            type: String,
        },
    }
</script>
